import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../../utils/liffHelper';
import { Redirect } from 'react-router-dom'
import Noredi from './ProfileNoredi'
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import InputLabel from '@material-ui/core/InputLabel';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(3, 2)
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: {
        pictureUrl: "https://cdn4.iconfinder.com/data/icons/men-avatars-icons-set-2/256/4-512.png",
        displayName: "DisplayName: LINENAME",
      },
      mongo: {
        Ck_Name: 'false'
      },
      redi: {
        redirect: false,
        redirectnogroup: false
      },
      keep: {
        password: this.props.location.state.password,
      },
      datafrom: {
        brace: ''
      },
      Ck_NameF: 'FFFFF',
      Ck_NameL: '',
      stacheck: {
        stacheck2: false
      },
      openS: false,
      openW: false,
      showselectadm: false,
      idfb: false,
      showselectname: false,
      password: this.props.location.state.password
    };


  }
  async componentDidMount() {

    // const profile = await liffHelper.initcontext()
    const profile = await liffHelper.getProfile()
    // alert(profile.groupId)
    this.setState({
      profile: {
        userId: profile.userId,
        groupId: profile.groupId,
        displayName: "DisplayName: " + profile.displayName,
        pictureUrl: profile.pictureUrl
      }
    })
    // alert(this.state.password)
///////////////////////////////RAFCO//////////////////////////
    if (this.state.password == "Admin") {
      const adm = await liffHelper.list(50, 'MsnRafco_Sender')
      if (adm != undefined) {
        // alert(nna[0].Ck_NameF)
        // alert(this.state.data)
        this.setState({
          showselectadm: adm
        });
      }
    }
///////////////////////////////RPLC//////////////////////////
  else  if (this.state.password == "rplc" || this.state.password == "motor") {
      const adm = await liffHelper.list(50, 'MsnRPLC_Sender')
      if (adm != undefined) {
        // alert(nna[0].Ck_NameF)
        // alert(this.state.data)
        this.setState({
          showselectadm: adm
        });
      }
    }
///////////////////////////////AICP//////////////////////////
else  if (this.state.password == "aicp") {
      const adm = await liffHelper.list(50, 'MsnAIC_Sender')
      if (adm != undefined) {
        // alert(nna[0].Ck_NameF)
        // alert(this.state.data)
        this.setState({
          showselectadm: adm
        });
      }
    }
  }


  closeWindow() {
    liffHelper.closeWindow()
  }


  renderRedirect = () => {
    // if (     
    // this.state.password != "Admin" ||
    // this.state.password != "rplc" ||
    // this.state.password != "motor") {
    //   return <Redirect
    //     to={{
    //       pathname: '/message',
    //       state: { id: this.state.keep.password }
    //     }}
    //   />
    // }
  }

  async savemongo() {
    if (this.state.Ck_NameF == '') {
      alert('required firtname')
    }
    else if (this.state.Ck_NameL == '') {
      alert('required lastname')
    }
    else if (this.state.datafrom.brace == '') {
      alert('required branch')
    } else if (this.state.idfb == false) {
      alert('required ID-Fb')
    } else {
      this.setState({
        openW: true
      });
      var collectq = 'Ck_Data'
      if (this.state.password == "rplc" || this.state.password == "motor") { collectq = 'Ck_Data_RPLC' }
      if (this.state.password == "aicp") { collectq = 'Ck_Data_AIC' }
      const inss = await liffHelper.insertadmin(
        this.state.profile.userId,
        this.state.profile.displayName, 
        this.state.profile.pictureUrl,
        this.state.Ck_NameF,
        this.state.Ck_NameL,
        this.state.datafrom.brace,
        this.state.idfb,
        collectq

      )
      if (inss != undefined) {
        if (inss.sta == 'AddSuccess' || inss.sta == 'Success!') {
          // alert(inss.sta)
          this.setState({
            stacheck: {
              ...this.state.stacheck,
              stacheck2: inss.sta,
            },
            openW: false,
            openS: true
          })
        } else {
          alert('มีข้อผิดพลาด ลองใหม่')
        }
      }
      // alert(nna.sta)
    }
  }
  Changbance(event) {
    alert(event.target.value)
    this.setState({ datafrom: { brace: event.target.value } });
    // alert(this.state.datafrom.brace)
  }
  async handleChangeadm(event) {

    //  const monget = await liffHelper.mongget(event.target.name) 
    // alert(event.target.value)
    // alert(event.target.value[0])
    // alert(event.target.value)
    // let v1 = event.target.value[0]
    // const checkin = await liffHelper.checkin(v1)
    this.setState({ showselectname: event.target.value });
    // alert(this.state.namecus)
  }
  async SearchOther() {
    var port = ''
    if(this.state.password == "rplc" || this.state.password == "motor"){port = '5019'}
    else if(this.state.password == "Admin"){port = '5030'}
    else if(this.state.password == "aicp"){port = '5032'}
    const fb = await liffHelper.getidfb(this.state.showselectname, port)
    // alert(nna)
    if (fb != undefined) {
      if (fb.ussr != undefined) {
        this.setState({
          idfb: fb.ussr
        });
        alert('Search Finish')
      } else if (fb.status != undefined) {
        alert(fb.status)
      } else {
        alert('error No status Please contact ก๊อต-AGS')
      }
    }
  }

  render() {
    const classes = this.props;

    return (
      // <div className={classes.root}>
      // <div>
      //   <Noredi />

      <div className={classes.root} >
        <Noredi />
        {this.renderRedirect()}
        <Paper className={classes.paper} style={{ marginTop: 10, padding: 30 }}>
          <CssBaseline />
          <div className={classes.paper} >
            <Avatar className={classes.avatar} src={this.state.profile.pictureUrl} />

            {/* </Avatar> */}
            <Typography component="h1" variant="h5">
              Register Admin
        </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.profile.displayName}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              <Dialog
                open={this.state.openW}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <CircularProgress />
                    <CircularProgress color="secondary" />
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* <Button  color="primary">
                    Disagree
                  </Button>
                  <Button  color="primary" autoFocus>
                    Agree
                  </Button> */}
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openS}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                {/* <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle> */}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    RegisAdmin {this.state.stacheck.stacheck2}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" onClick={event => this.setState({ openS: false })}>
                    Retry
                  </Button>
                  <Button color="primary" autoFocus onClick={this.closeWindow.bind(this)}>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.profile.userId}
                // label={this.state.stacheck.stacheck2}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              {
                (this.state.password == "rplc" || this.state.password == "motor" || this.state.password == "Admin")
                  ?
              <FormControl className={classes.margin}>
                <InputLabel id="demo-customized-select-label">Branch</InputLabel>
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={this.state.datafrom.brace}
                  // onChange={this.Changbance.bind(this)}
                  onChange={event => this.setState({ datafrom: { brace: event.target.value } })}
                  input={<BootstrapInput />}
                  label="Select Branch"
                  labelWidth='50'
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"PNP"}>PNP</MenuItem>
                  <MenuItem value={"BTB"}>BTB</MenuItem>
                  <MenuItem value={"MCM"}>MCM</MenuItem>
                </Select>
              </FormControl>
              :
              null
          }
                        {
                (this.state.password == "aicp")
                  ?
              <FormControl className={classes.margin}>
                <InputLabel id="demo-customized-select-label">Branch</InputLabel>
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={this.state.datafrom.brace}
                  // onChange={this.Changbance.bind(this)}
                  onChange={event => this.setState({ datafrom: { brace: event.target.value } })}
                  input={<BootstrapInput />}
                  label="Select Branch"
                  labelWidth='50'
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"PNP"}>MPN</MenuItem>
                  <MenuItem value={"BTB"}>MBT</MenuItem>
                </Select>
              </FormControl>
              :
              null
          }
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                // id="email"
                label="Admin Messenger Rafco"
                label="Fistname"
                name="Fistname"
                autoComplete="Fistname"
                autoFocus
                onChange={event => this.setState({ Ck_NameF: event.target.value })}
              // disabled="disabled"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Lastname"
                name="Lastname"
                autoComplete="Lastname"
                autoFocus
                onChange={event => this.setState({ Ck_NameL: event.target.value })}
              // disabled="disabled"
              />
              {
                (this.state.showselectadm != false)
                  ?
                  <FormControl className={classes.margin} >
                    <InputLabel shrink htmlFor="age-native-label-placeholder">DisplaynameFacebook</InputLabel>
                    <Select className="width50" value={this.state.showselectname} onChange={this.handleChangeadm.bind(this)}
                      input={<BootstrapInput />}
                      label="Select Branch"
                      labelWidth='50'
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                    >
                      {this.state.showselectadm.map((dt, i) => {
                        // alert(dt.Ck_NameF)
                        return (
                          <MenuItem
                            label="Select Customer"
                            // value={dt.MsnName}
                            value={dt.MsnName}
                            key={i} name={dt.MsnName}>{dt.MsnName}</MenuItem>

                        );
                      })}
                    </Select>
                    {/* <h3>Selected  - {this.state.selected}</h3> */}
                  </FormControl>
                  :
                  null
              }
              {
                (this.state.showselectname != false)
                  ?
                  <Grid container style={{ marginTop: 10 }} >
                    <Button variant="outlined" color="secondary" onClick={this.SearchOther.bind(this)}>
                      Search ID Facebook
                    </Button>
                  </Grid>
                  :
                  null
              }
              {
                (this.state.idfb != false)
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="email"
                    // label="Admin Messenger Rafco"
                    label={this.state.idfb}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.idfb != false)
                  ?
                  <Button variant="outlined" color="primary" onClick={this.savemongo.bind(this)}>
                    SAVE
              </Button>
                  :
                  null
              }
            </form>
          </div>
          <h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1>
        </Paper>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// src/pages/components/RegisAdmin.js